import { c as _c } from "react/compiler-runtime";
import type { ManagerOnMessage } from '@module/types/centrifuge/public-message/managerMessageTypes';
interface Props {
  item: ManagerOnMessage;
}
export default function ManagerOnChat(props) {
  const $ = _c(2);
  const {
    item
  } = props;
  const {
    message
  } = item.data;
  const t0 = `${message.nick}님께서 매니저에 임명되었습니다.`;
  let t1;
  if ($[0] !== t0) {
    t1 = <div className="mb-[3px] whitespace-pre-wrap text-cht_al_1"><div>{t0}</div></div>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}